import * as React from "react"
import {Avatar, Box, Divider, IconButton, Typography} from "@mui/material";
import {IconSeeker, PopoverSeeker} from "@ui-seeker/core";

import {AppLink} from "../../../../@componets";
import {appLogoutURL, appUsername} from "../../../../@signals";
import { dsColorNew } from "@palette";
import MaximalLayoutHeaderchevronToolbar from "../chevronToolbar";
import {handleLangPopoverClose, openUserPopover} from "./signals";
import MaximalLayoutHeaderUserOption from "./UserOption";


export default function MaximalLayoutHeaderUserTool({ links=[] }) {
	const initial = appUsername.value?.[0]?.toUpperCase() || '?'

	return <>
		<IconButton aria-label={appUsername.value} onClick={e => openUserPopover.value = e.currentTarget} sx={{
			color: dsColorNew.textTitle, height: 40, p: '0 12px 0 6px', gap: 1,
			backgroundColor: dsColorNew.white, borderRadius: '10px',
			border: `1px solid ${dsColorNew.grayBorder}`,
			'&:hover': { backgroundColor: dsColorNew.filterInputBg }
		}}>
			<Avatar sx={{ width: 28, height: 28, bgcolor: dsColorNew.appBlue, fontSize: 13, fontWeight: 700, color: dsColorNew.white }}>
				{initial}
			</Avatar>
			{/* under 1200 px the name gives its room to the page title; the initial and the menu stay */}
			<Typography variant="body2" sx={{ display: { xs: 'none', lg: 'block' }, fontWeight: 500, fontSize: 13, color: dsColorNew.textTitle }}>
				{appUsername.value}
			</Typography>
			<MaximalLayoutHeaderchevronToolbar isOpen={openUserPopover.value} />
		</IconButton>

		<PopoverSeeker anchorEl={openUserPopover.value} onClose={handleLangPopoverClose}>
			<AppLink to="/" sx={{ color: "text.primary" }}>
				<MaximalLayoutHeaderUserOption icon="home" text="Home"  />
			</AppLink>

			<Divider sx={{ borderStyle: 'dashed' }} />

			{!!links && links.map(({ url, icon, text }, index) => url && icon && text ? <div key={index}>
				<AppLink to={url} sx={{ color: "text.primary" }}>
					<MaximalLayoutHeaderUserOption icon={icon} text={text} />
				</AppLink>
				{index < links.length && <Divider sx={{ borderStyle: 'dashed' }} />}
			</div> : null)}

			<AppLink to={appLogoutURL.value} sx={{ color: "text.primary" }}>
				<MaximalLayoutHeaderUserOption icon="right-from-bracket" text="Logout" />
			</AppLink>
		</PopoverSeeker>
	</>
}